<template>
    <div>
        <text-header id="supplementary-agreements">Дополнительные соглашения</text-header>
        <div v-if="purchase.supplementary_agreements.length > 0" class="accordion" role="tablist">
            <component
                :is="supplementaryAgreementComponent(supplementaryAgreement)"
                v-for="(supplementaryAgreement, key) in purchase.supplementary_agreements"
                :key="`supplementary-agreement-${key}`"
                :purchase="purchase"
                :title="`${supplementaryAgreement.fl44_contract_supplementary_agreement_type.title} №${supplementaryAgreement.number}`"
                :supplementary-agreement="supplementaryAgreement"
                :visible="purchase.last_supplementary_agreement_id === supplementaryAgreement.id"
                @refresh="done" />
        </div>
        <template v-if="isPurchaseCreator() && purchase.status.id === 'contract:active'">
            <b-dropdown text="Добавить дополнительное соглашение" variant="custom-green" class="mt-1" v-if="!isCreate">
                <b-dropdown-item class="fs-14" v-for="type in $globalDictionaries.fl44SupplementaryAgreementTypes" :key="type.id" @click="createClicked(type.id)">{{ type.title }}</b-dropdown-item>
            </b-dropdown>
            <component :is="createComponent" v-else :purchase-id="purchase.id" :purchase="purchase" @cancel="isCreate = false" @done="done" />
        </template>
    </div>
</template>

<script>
import SupplementaryAgreementItem from '@/components/externalPurchases/partials/supplementary-agreement-item.vue';
import CreateSupplementaryAgreements from '@/components/externalPurchases/partials/create-supplementary-agreement.vue';
import ExternalCreateSupplementaryAgreementTermination from '@/components/externalPurchases/partials/external-create-supplementary-agreement-termination.vue';
import Fl44ExternalPurchaseSupplementaryAgreementTerminationItem from '@/components/externalPurchases/partials/fl44-external-purchase-supplementary-agreement-termination-item.vue';

export default {
    name: 'supplementary-agreements',
    components: { CreateSupplementaryAgreements },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isCreate: false,
            type: 'regular'
        };
    },
    methods: {
        createClicked(typeId) {
            this.type = typeId;
            this.isCreate = true;
        },
        done() {
            this.$emit('refresh');
            this.isCreate = false;
        },
        supplementaryAgreementComponent(supplementaryAgreement) {
            switch (supplementaryAgreement.fl44_contract_supplementary_agreement_type.id) {
                case 'termination':
                    return Fl44ExternalPurchaseSupplementaryAgreementTerminationItem;
                default:
                    return SupplementaryAgreementItem;
            }
        }
    },
    computed: {
        createComponent() {
            switch (this.type) {
                case 'termination':
                    return ExternalCreateSupplementaryAgreementTermination;
                default:
                    return CreateSupplementaryAgreements;
            }
        }
    }
};
</script>
